<template>
<field :label="label">
  <div class="control">
    <datepicker input-class="input" placeholder="Select Date" v-model="val">
    </datepicker>
  </div>
</field>
</template>

<script>
import Field from '@/components/general/field'
import Datepicker from 'vuejs-datepicker'

export default {
  components: { Field, Datepicker },
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: Date
    }
  },
  computed: {
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value) }
    }
  },
  methods: {
    hide () {
      this.calendar.hide()
      console.log('hiding')
    }
  },
  data () {
    return {
      disabled: {
        to: new Date()
      },
      calendar: null,
      selectedDate: new Date()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.control /deep/ .vdp-datepicker {
}
</style>



// WEBPACK FOOTER //
// src/components/general/date-picker.vue